import { render, staticRenderFns } from "./view_stock.vue?vue&type=template&id=2f49b758&scoped=true"
import script from "./view_stock.vue?vue&type=script&lang=js"
export * from "./view_stock.vue?vue&type=script&lang=js"
import style0 from "./view_stock.vue?vue&type=style&index=0&id=2f49b758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49b758",
  null
  
)

export default component.exports